import type { MuscleInfo } from '@az3fr/core';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { api } from '@/api/api-client';
import { muscleSliceActions } from '@/entities/muscle/model/muscle.slice';
import { useAppDispatch } from '@/hooks/store.hook';

// @TODO: get this from the @az3fr/functions package
interface MusclesResponse {
	data: MuscleInfo[];
}

function useLoadAllMusclesRawQuery() {
	const dispatch = useAppDispatch();

	// @todo: fix the typing
	const queryResult = useQuery<MusclesResponse, Error>({
		queryKey: ['muscles', 'all', 'raw'],
		queryFn: () => api.get<MusclesResponse>('muscles/raw'),
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
	});

	// Automatically cache fetched movements in the normalized store
	useEffect(() => {
		if (queryResult.data?.data) {
			dispatch(muscleSliceActions.setAll(queryResult.data.data));
		}
	}, [queryResult.data, dispatch]);

	return queryResult;
}

export { useLoadAllMusclesRawQuery };
